<template>
  <div>
    <div class="content-title">
      <div>
        <span>C.E. 2003 -</span>
        <h2>社會多元</h2>
      </div>
    </div>
    <div class="content-img">
      <picture>
        <source srcset="../../assets/images/multiple/multiple-m.png" media="(max-width: 480px)">
        <img src="../../assets/images/multiple/multiple.png" alt="">
      </picture>
    </div>
    <div class="wrapper">
      <p style="text-align: center"><small>撰文/燕珍宜</small></p>
      <p>去年移民署特考放榜，其中一位新科移民官成為關注焦點，她是來自越南的嚴沛瀅，也是移民署首位高階新住民移民官。個子特顯嬌小的她，穿上警察大禮服制服依舊英氣煥發，開口說話後，特殊口音才顯露她與眾不同的背景。</p>
      <p>二十多年前剛嫁到台灣時，僅會簡單中文，連溝通、買東西都有困難。「每天一睜開眼，就有做不完的家事，每天洗地板、洗紗窗、洗拖鞋⋯⋯。」當時先生仍在越南工作，跟婆婆住在一起的嚴沛瀅，經歷一段偷偷流淚的辛苦日子。「自己千里迢迢、離鄉背井來到台灣，難道就這樣洗洗刷刷過一輩子嗎？」</p>
      <p>回想當時，台灣社會充滿對東南亞女性的刻板印象。「鄰居很多人會問我婆婆，娶這個媳婦要花多少錢？」明明是與老公自由戀愛才結婚來台，卻避免不了當時「越南新娘」的異樣眼光。</p>
      <figure class="article-img">
        <img src="../../assets/images/multiple/pic-01.png" alt="">
        <figcaption>外籍新年來台逐漸攀高，據2002年統計，每4對新婚夫婦，就有1對是台灣與外籍人士的組合。</figcaption>
      </figure>
      <p>2002年，四對結婚新人中就有一對是台灣與外籍人士的組合。這些異國婚姻女性在沒有一技之長、語言不通下，一來台，幾乎注定被鎖在夫家，嚴沛瀅當時也是如此。</p>
      <p>如果當時台灣不對外籍新娘做些什麼，你可以想像現在台灣社會會是什麼模樣？一直躲在家庭角落的媽媽，與可能無法跟上學習進度的孩子⋯⋯。</p>
      <p>到了2003年，行政院開始籌備設置「外籍配偶照顧輔導基金」。隨後一連串政策與無數公益團體協助，讓這些從異國來台的婚姻移民慢慢進入學校、社區，與台灣社會愈來愈靠近。而台灣社會氛圍也逐漸改變，例如對她們的稱呼從「外籍新娘」到「新住民」，這潛移默化的改變，形塑了台灣社會對新住民的新態度。</p>
      <figure class="article-img">
        <img src="../../assets/images/multiple/pic-02.png" alt="">
        <figcaption>內政部與教育部共同推動「火炬計畫」，服務新住民與其子女建立新住民支持系統。</figcaption>
      </figure>
      <p>隨著新住民小孩進入小學，校園裡多了一群「不一樣」的小孩。「確實，當時會注意他們學習有些落後，或者親師會時，有些媽媽站在很後面不敢講話。」現為內政部移民署移民事務組專門委員李明芳說。</p>
      <p>當時李明芳任職台北縣教育局，而台北縣（現更名新北市）也成為第一個推出新住民政策的地方政府。台北縣副縣長李鴻源則是少數了解問題嚴重性的首長，他分享一個心痛的小故事。當年他到萬里國小視察，遇到一位新住民小朋友，他問道：「你媽媽是哪裡人？」一連問了三遍，小朋友才脹紅著臉回答：「我媽媽是大陸妹。」</p>
      <p>「當下我驚覺，包括老師、同學、整個社會都需要被重新教育。」</p>
      <p>2007年，他將原本贊助煙火的經費，轉為「新住民火炬計畫」的第一筆種子基金，輔導新住民小孩學習。2012年，內政部與教育部共同推動「火炬計畫」，建立新住民支持系統。</p>
      <figure class="article-img">
        <img src="../../assets/images/multiple/pic-03.png" alt="">
        <figcaption>嚴沛瀅來台20多年，不斷學習提升自己，最後成為移民署首位來自越南的新住民移民官。</figcaption>
      </figure>
      <p>隨著政府首長與民間組織對新住民議題的重視，嚴沛瀅也報名參加法院、勞工局舉辦的通譯課程，結業後在法院擔任兼職翻譯。後來，廣播電台推出一個直播節目《寶島湄江情》，嚴沛瀅一開始是擔任翻譯，最後晉升主持人，負責接聽聽眾Call-in電話、回覆來信，讓她的口才與反應大幅提升。</p>
      <p>此外，她還在板橋社區大學教授越南語，學生中不少是企業老闆。嚴沛瀅之後更成立台灣新移民文化交流協會，擔任理事長，舉辦各式活動與課程，社區大學的同學儼然成為她最大的支持力量。</p>
      <p>2007年移民署剛成立，嚴沛瀅正巧看到網站要徵聘約雇人員，但條件是須具備大學學歷。於是，一邊擔任翻譯、一邊修讀空中大學，拿到畢業證書後正式成為移民署的約雇人員。</p>
      <p>但多數約雇人員的共同願望是能通過國考取得公務人員身分，嚴沛瀅也不例外。「我的考運沒那麼順利，連續四年落榜。」就在告訴自己這是最後一次機會時，皇天不負苦心人，終於夢想成真，在去年收到錄取通知。</p>
      <figure class="article-img">
        <img src="../../assets/images/multiple/pic-04.png" alt="">
        <figcaption>2018年國慶大典由越南新住民阮秋姮主持。</figcaption>
      </figure>
      <p>而在2018年台灣也進入多元發聲期，台灣史上第一位當選立委的新住民林麗嬋，獲提名出任不分區立委；國慶大典由越南新住民阮秋姮主持。根據內政部資料統計，新住民也已超過65萬人，成為閩南、客家與外省人之外的第四大族群。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
